/* istanbul ignore file */
import { NIKECOM_CHANNEL, NIKE_BRAND } from '@nike/ux-tread-dotcom-constants';
import getWebShellClientLocale from "../../../../../utils/get-webshellclient-locale";
var getURLBase = function getURLBase() {
  var country = getWebShellClientLocale().country;
  var brand = NIKE_BRAND;
  var channel = NIKECOM_CHANNEL;
  return "".concat(process.env.NEXT_PUBLIC_API_HOST_NAME, "/buy/carts/v2/").concat(country.toUpperCase(), "/").concat(brand, "/").concat(channel);
};
export default getURLBase;